import React, { Component } from "react";
import { Images } from "../../theme";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./styles.css";

export default () => {
  const { t } = useTranslation();

  return (
    <div className="bg-footer mb-0">
      <div className="container">
        <div className="row upper-footer">
          <div className="col-lg-4 col-md-12">
            <img
              className="logo-icon"
              style={{ paddingBottom: 25 }}
              src={Images.logo_blue}
              alt="image"
            />
            <p className="limited-text justify">{t("Footer_Description")}</p>
            <div className="footer-icon-container mt-4">
              <span className="foot-span">
                <i className="fa fa-facebook foot-icon"></i>
              </span>
              <span className="foot-span">
                <i className="fa fa-twitter foot-icon"></i>
              </span>
              <span className="foot-span">
                <i className="fa fa-youtube foot-icon"></i>
              </span>
              <span className="foot-span">
                <i className="fa fa-linkedin foot-icon"></i>
              </span>
              <span className="foot-span">
                <i className="fa fa-instagram foot-icon"></i>
              </span>
            </div>
          </div>
          <div className="col-lg-1  d-none-mobile" />
          <div className="col-lg-2 col-6">
            <p className="footer-heading Poppins">{t("Elephant_Please")}</p>
            <Link to="/Renting">
              <p className="limited-text Poppins">{t("How_Renting_Works")}</p>
            </Link>
            <Link to="/Lending">
              <p className="limited-text Poppins">{t("How_Lending_Works")}</p>
            </Link>
            <Link to="/Faqs">
              <p className="limited-text Poppins">{t("FAQs")}</p>
            </Link>
          </div>
          <div className="col-lg-1 d-none-mobile" />
          <div className="col-lg-2 col-6 terms-sec">
            <p
              style={{ color: "rgba(236, 247, 255, 1)" }}
              className="footer-heading Poppins"
            >
              {t("Elephant_Please")}
            </p>
            <Link to="/termsofuse">
              <p className="limited-text Poppins">{t("Terms_Of_Use")}</p>
            </Link>
            <Link to="/PrivacyPolicy">
              <p className="limited-text Poppins">{t("Privacy_Policy")}</p>
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-container">
        <p className="footer-text mb-0 Poppins">
          &copy; {t("Elephant_Please")} 2022
        </p>
      </div>
    </div>
  );
};
